<template>
  <div class="group-list" style="height:124px;position:relative">
    <Spin fix v-if="isLoading">
      <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div
      v-for="i in getGroupByType[gType].careplans"
      class="card-container" style="position:relative"
      :key="getCareplan(i).id">
      <span class="star-org" v-if="gType == 'alliance'" @click="setPrimaryOrg(i)">
        <Icon class="stroked-star" v-if="info.data.primary_org == getCareplan(i).id" type="ios-star" style="color:orange" size='25'></Icon>
        <Icon v-else type="ios-star-outline" size='25'></Icon>
      </span>
      <div @click="goToGroup(getCareplan(i).id)" class="event-holder" v-if="i && i.pages && i.pages[0].data  && i.pages[0].data.event_start_date && gType == 'event'">
        <Row style="textAlign:center;lineHeight:1;display: inline-block;">
          <div style="vertical-align: baseline;color:red;vertical-align:middle;font-size: 14px;">{{parseDateToMonth(i.pages[0].data.event_start_date)}}</div>
          <div style="text-align: center;font-size: 33px;display: flex;align-items: center;justify-content: center;">{{parseDateToDay(i.pages[0].data.event_start_date)}}</div>
          <div style="vertical-align: middle;font-size: 12px;align-self: self-end;">{{parseDateToYear(i.pages[0].data.event_start_date)}}</div>
        </Row>
      </div>
      <Card :padding="1">
        <div style="height:120px" @click="goToGroup(getCareplan(i).id)">
          <div class="card-content">
            <Icon type="star-outline"/>
            <img style="width:auto;height:100%" :src="getAvatar(i)" v-if="gType != 'event'"/>
          </div>
          <div style="padding:0 3px;">
            <p class="content-ellipsis">{{getCareplan(i).title}}</p>
          </div>
        </div>
      </Card>
    </div>
    <div v-if="!isCurrentUser && !isLoading && getGroupByType[gType].careplans.length <= 0">
      <p style="color:#ddd;line-height:114px" align="center">No items to show</p>
    </div>
    <div class="card-container" v-if="isCurrentUser && gType !== 'public'">
      <Card :padding="1">
        <router-link tag='div' :to="reRoute" style="height:120px">
          <div class="card-content" style="background:#fff;height:120px;text-align:center">
            <Icon type="plus" style="display:block;line-height:120px;color:#ddd" size="50" />
          </div>
        </router-link>
      </Card>
    </div>
  </div>
</template>

<script>
import Utils from '@/utils.js'
import moment from 'moment'

export default {
  name: 'CardViewGroup',
  data() {
    return {
      isLoading: false
    }
  },
  props: {
    journal: {
      type: Object
    },
    isCurrentUser: {
      type: Boolean
    },
    gType: {
      type: String
    }
  },
  methods: {
    setPrimaryOrg(stuff) {
      let set = (this.info.data.primary_org === stuff.careplan.id) ? 'unset':'set';
      let data = {
        'meta': {'primary_org': (set == 'set') ? stuff.careplan.id:null}
      };
      this.$Modal.confirm({
        title: 'Title',
        content: (set == 'set') ? 'Set as primary Organization?':'Unset as primary Organization?',
        onOk: () => {
          this.$store.dispatch('publicProfile/setPrimaryOrg', {id: this.info.data.id, data})
            .then(res => {
            this.info.data.primary_org = res.primary_org
            this.$store.dispatch('publicProfile/getUserOrg', {id:this.info.data.primary_org})
          });
        }
      });

    },
    loadGroups() {
      this.isLoading =true;
      this.$store.dispatch('publicProfile/getUserGroupByType', {id: this.id,type: this.gType})
        .then( res=> {
          this.isLoading = false
        }, err=> {
          this.isLoading = false
        })
    },
    goToGroup(id) {
      if(this.gType == "event"){
        this.$router.push({
          path: '/resources/' + id , query:{type:'event'}
        })
      }else{
        this.$router.push('/resources/'+id)
      }
    },
    getAvatar(stuff) {
      return Utils.getDisplayImage('group', stuff.careplan, 'medium')
    },
    parseDateToMonth(date) {
      var d = new Date(date)
      return moment(d,"YYYY-MM-DD").format("MMM").toUpperCase()
    },
    parseDateToDay(date) {
      var d = new Date(date)
      return moment(d,"YYYY-MM-DD").format("DD").toUpperCase()
    },
    parseDateToYear(date) {
      var d = new Date(date)
      return moment(d,"YYYY-MM-DD").format("YYYY").toUpperCase()
    },
    getCareplan(v) {
      if(this.gType == 'event'){
        return v
      }else{
        return v.careplan
      }
    }
  },
  computed: {
    info: {
      get() {
        return this.$store.state.publicProfile.info
      }
    },
    id() {
      return this.journal.journal_id
    },
    reRoute() {
      switch(this.gType) {
        case 'interest':
          return '/group-type/interest';
          break;
        case 'event':
          return '/group-type/event';
          break;
        case 'alliance':
          return '/group-type/alliance';
          break;
      }
    },
    getGroupByType: {
      get() {
          return this.$store.state.publicProfile.myGroupType
      }
    }
  },
  watch: {
    '$route': function(n,o) {
      let isSameUser = this.$store.state.publicProfile.info.previousUserId == this.$route.params.uid;
      if( !isSameUser && n ) this.loadGroups()
    }
  },
  mounted() {
    this.loadGroups()
  }
}
</script>

<style scoped>
  .stroked-star {
    -webkit-text-stroke: 1px;
    -webkit-text-stroke-color: #494f61;
  }
  .star-org {
    position:absolute;
    z-index: 1;
    left: 1px;
    top: 1px;
    border-bottom-right-radius: 5px;
    text-align: center;
    width: 25px;
    height: 25px;
    background: #fff;
  }
  .event-holder {
    position: absolute;
    z-index: 1;
    left: 2px;
    top: 2px;
    text-align: center;
    width: 85px;
    height: 85px;
    background: rgba(255, 255, 255, 0);/*set tranparency*/
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-content {
    width:85px;
    height:85px;
    overflow:hidden;
    background:#f2f2f2;
  }
  .content-ellipsis {
    width: 80px;
    font-size: 12px;
    padding-top: 3px;
    display: block;
    display: -webkit-box;
    line-height: 1.25em;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: pre-line;
    text-overflow: ellipsis;
  }
  .group-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
  .card-container {
    vertical-align: top;
    width: 90px;
    display: inline-block;
    margin-left: 10px;
  }
</style>
